import { LCWorkTriple, VariantWithTriples } from "@libry-content/integrations";
import { ManifestationStatusForUserType } from "../manifestations/useManifestationStatusForUser";

/**
 * Check if reservation of material should be disabled.
 * Can take both workTriple and variant as props, as disabling works a bit differently between them.
 * e.g. check if reservation of variant should be disabled when reserving from variant
 * and check if reservation of workTriple should be disabled when reserving a specific manifestation.
 * */
export const isReservationDisabled = ({
  workTriple,
  variant,
  manifestationStatusForUser,
}: {
  workTriple?: LCWorkTriple;
  variant?: VariantWithTriples;
  manifestationStatusForUser: ManifestationStatusForUserType;
}) => {
  if (variant) return isVariantReservationDisabled({ variant, manifestationStatusForUser });
  if (workTriple) return isTripleReservationDisabled({ workTriple, manifestationStatusForUser });
  return true;
};

const isVariantReservationDisabled = ({
  variant,
  manifestationStatusForUser,
}: {
  variant: VariantWithTriples;
  manifestationStatusForUser: ManifestationStatusForUserType;
}) => {
  // Hvis variant inneholder bind, vil vi at låner skal kunne reservere selv om de har reservert noe i varianten fra før
  // (slik at de f.eks. kan låne både bind 1 og bind 2, selv om de er del av samme variant)
  const variantIsParted = variant.workTriples.some((workTriple) => workTriple.isPartedTriple);
  if (variantIsParted) return false;
  return !!(manifestationStatusForUser.isLoanedByUser || !!manifestationStatusForUser.isReservedByUser);
};

const isTripleReservationDisabled = ({
  workTriple,
  manifestationStatusForUser,
}: {
  workTriple: LCWorkTriple;
  manifestationStatusForUser: ManifestationStatusForUserType;
}) => {
  const tripleIsLoaned = manifestationStatusForUser.loanedTriples?.find(
    (loanedTriple) => loanedTriple.manifestationId === workTriple.manifestationId
  );
  const tripleIsReserved = manifestationStatusForUser.reservedTriples?.find(
    (reservedTriple) => reservedTriple.manifestationId === workTriple.manifestationId
  );
  if (tripleIsLoaned || tripleIsReserved) return true;
  // Dersom en manifestasjon / trippel er et bind / én del av et verk, vil vi at den kun skal være disabled hvis den spesifikt er reservert av bruker
  if (!workTriple.isPartedTriple)
    return !!(manifestationStatusForUser.isLoanedByUser || !!manifestationStatusForUser.isReservedByUser);
  return false;
};
